(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    function initCart(root) {
      if (!root || root.dataset.twCartReady === '1') return;
      var form = root.querySelector('.tw-cart__form');
      if (!form) return;
      root.classList.add('is-enhanced');
      root.dataset.twCartReady = '1';

      root.querySelectorAll('[data-tw-cart-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('[data-tw-cart-item]');
          var input = item.querySelector('[data-tw-cart-input]');
          var v = parseInt(input.value, 10);
          if (isNaN(v)) v = 0;
          v = Math.max(0, v + parseInt(btn.getAttribute('data-tw-cart-step'), 10));
          input.value = v;
          submitUpdate();
        });
      });
      root.querySelectorAll('[data-tw-cart-input]').forEach(function (input) {
        input.addEventListener('change', submitUpdate);
      });

      var submitting = false;
      function submitUpdate() {
        if (submitting) return;
        submitting = true;
        var btn = root.querySelector('[data-tw-cart-update]');
        if (btn && form.requestSubmit) { form.requestSubmit(btn); }
        else if (btn) { btn.click(); }
        else { form.submit(); }
      }
    }
    function initAll(scope) { (scope || document).querySelectorAll('[data-tw-cart]').forEach(initCart); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { initAll(); }); }
    else { initAll(); }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-art-product-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    'use strict';

    const mount = (section) => {
      if (!section || section.dataset.productMounted === 'true') return;
      section.dataset.productMounted = 'true';

      const mainImage = section.querySelector('[data-gallery-main]');
      const thumbs = Array.from(section.querySelectorAll('[data-gallery-thumb]'));
      const select = section.querySelector('[data-variant-select]');
      const price = section.querySelector('[data-product-price]');
      const mobilePrice = section.querySelector('[data-mobile-price]');
      const compare = section.querySelector('[data-product-compare]');
      const stock = section.querySelector('[data-product-stock]');
      const addButton = section.querySelector('[data-add-button]');

      const activateMedia = (button) => {
        if (!button || !mainImage) return;
        thumbs.forEach((thumb) => thumb.setAttribute('aria-pressed', String(thumb === button)));
        mainImage.classList.add('is-changing');
        window.setTimeout(() => {
          mainImage.src = button.dataset.src || mainImage.src;
          mainImage.srcset = button.dataset.srcset || '';
          mainImage.alt = button.dataset.alt || '';
          mainImage.classList.remove('is-changing');
        }, 120);
      };

      thumbs.forEach((button) => button.addEventListener('click', () => activateMedia(button)));

      const updateVariant = () => {
        const option = select?.selectedOptions?.[0];
        if (!option) return;

        const available = option.dataset.available === 'true';
        const nextPrice = option.dataset.price || '';
        const nextCompare = option.dataset.compare || '';
        const inventory = Number.parseInt(option.dataset.inventory || '0', 10);

        if (price) price.textContent = nextPrice;
        if (mobilePrice) mobilePrice.textContent = nextPrice;
        if (compare) {
          compare.textContent = nextCompare;
          compare.classList.toggle('is-hidden', !nextCompare);
        }
        if (addButton) {
          addButton.disabled = !available;
          addButton.textContent = available ? addButton.dataset.availableLabel : addButton.dataset.soldLabel;
        }
        if (stock) {
          const total = Number.parseInt(stock.dataset.editionTotal || '0', 10);
          const showCount = stock.dataset.showCount === 'true';
          stock.classList.toggle('is-closed', !available);
          if (!available) {
            stock.textContent = stock.dataset.closedLabel || '';
          } else if (showCount && inventory > 0 && total > 0) {
            stock.textContent = `${stock.dataset.countPrefix || ''} ${inventory} ${stock.dataset.countMiddle || ''} ${total}`.trim();
          } else {
            stock.textContent = stock.dataset.availableLabel || '';
          }
        }

        if (option.dataset.mediaId) {
          const mediaButton = thumbs.find((thumb) => thumb.dataset.mediaId === option.dataset.mediaId);
          if (mediaButton) activateMedia(mediaButton);
        }
      };

      select?.addEventListener('change', updateVariant);
    };

    const mountAll = (scope = document) => {
      if (scope.matches?.('[data-tw-art-product]')) mount(scope);
      scope.querySelectorAll?.('[data-tw-art-product]').forEach(mount);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => mountAll(), { once: true });
    } else {
      mountAll();
    }

    document.addEventListener('shopify:section:load', (event) => mountAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-dossier-detail"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initDoss(root) {
      if (!root || root.dataset.twDossReady === '1') return;
      var links = Array.prototype.slice.call(root.querySelectorAll('[data-tw-doss-link]'));
      var parts = Array.prototype.slice.call(root.querySelectorAll('[data-tw-doss-part]'));
      if (!links.length || !parts.length) return;
      var byKey = {};
      links.forEach(function (l) { byKey[l.getAttribute('data-tw-doss-link')] = l; });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var key = e.target.getAttribute('data-tw-doss-part');
          links.forEach(function (l) { l.classList.toggle('is-active', l === byKey[key]); });
        });
      }, { rootMargin: '-30% 0px -60% 0px', threshold: 0 });
      parts.forEach(function (p) { io.observe(p); });
      root.dataset.twDossReady = '1';
    }
    function initAll(scope) { (scope || document).querySelectorAll('[data-tw-doss]').forEach(initDoss); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { initAll(); }); }
    else { initAll(); }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-header-control-v3"] && !Shopify.designMode) return;
  try {
    
(() => {
  const mounted = new WeakSet();

  const mount = (header) => {
    if (!header || mounted.has(header)) return;
    mounted.add(header);

    const megas = [...header.querySelectorAll('[data-tws3-mega]')];
    const drawerOpeners = [...header.querySelectorAll('[data-twhead-open]')];
    const desktop = window.matchMedia('(min-width: 1321px)');

    const setState = (mega, open) => {
      const trigger = mega.querySelector('[data-tws3-trigger]');
      const panel = mega.querySelector('[data-tws3-panel]');
      mega.toggleAttribute('data-open', open);
      trigger?.setAttribute('aria-expanded', String(open));
      if (panel) panel.hidden = !open;
    };

    const closeAll = (except = null, restore = false) => {
      megas.forEach((mega) => {
        if (mega === except || !mega.hasAttribute('data-open')) return;
        const trigger = mega.querySelector('[data-tws3-trigger]');
        setState(mega, false);
        if (restore) trigger?.focus();
      });
    };

    megas.forEach((mega) => {
      const trigger = mega.querySelector('[data-tws3-trigger]');
      const panel = mega.querySelector('[data-tws3-panel]');
      if (!trigger || !panel) return;

      setState(mega, false);

      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const shouldOpen = !mega.hasAttribute('data-open');
        closeAll(mega);
        setState(mega, shouldOpen);
      });

      panel.addEventListener('click', (event) => event.stopPropagation());
      panel.querySelectorAll('a[href]').forEach((link) => {
        link.addEventListener('click', () => closeAll());
      });
    });

    drawerOpeners.forEach((button) => {
      button.addEventListener('click', () => closeAll());
    });

    document.addEventListener('click', (event) => {
      if (!header.contains(event.target)) closeAll();
    });

    header.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const openMega = megas.find((mega) => mega.hasAttribute('data-open'));
      if (!openMega) return;
      event.preventDefault();
      const trigger = openMega.querySelector('[data-tws3-trigger]');
      setState(openMega, false);
      trigger?.focus();
    });

    const syncBreakpoint = () => {
      if (!desktop.matches) closeAll();
    };
    desktop.addEventListener?.('change', syncBreakpoint);
    syncBreakpoint();
  };

  const collect = (scope = document) => {
    if (scope.matches?.('[data-tws3]')) mount(scope);
    scope.querySelectorAll?.('[data-tws3]').forEach(mount);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => collect(), { once: true });
  } else {
    collect();
  }

  document.addEventListener('shopify:section:load', (event) => collect(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-header-control-v4"] && !Shopify.designMode) return;
  try {
    
(() => {
  const mounted = new WeakSet();

  const mount = (header) => {
    if (!header || mounted.has(header)) return;
    mounted.add(header);

    const megas = [...header.querySelectorAll('[data-tws3-mega]')];
    const drawerOpeners = [...header.querySelectorAll('[data-twhead-open]')];
    const desktop = window.matchMedia('(min-width: 1321px)');
    const hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 1321px)');
    const closeTimers = new WeakMap();

    const clearClose = (mega) => {
      const timer = closeTimers.get(mega);
      if (timer) window.clearTimeout(timer);
      closeTimers.delete(mega);
    };

    const setState = (mega, open) => {
      const trigger = mega.querySelector('[data-tws3-trigger]');
      const panel = mega.querySelector('[data-tws3-panel]');
      mega.toggleAttribute('data-open', open);
      trigger?.setAttribute('aria-expanded', String(open));
      if (panel) panel.hidden = !open;
    };

    const closeAll = (except = null, restore = false) => {
      megas.forEach((mega) => {
        clearClose(mega);
        if (mega === except || !mega.hasAttribute('data-open')) return;
        const trigger = mega.querySelector('[data-tws3-trigger]');
        setState(mega, false);
        if (restore) trigger?.focus();
      });
    };

    const openMega = (mega) => {
      clearClose(mega);
      closeAll(mega);
      setState(mega, true);
    };

    const scheduleClose = (mega, delay = 150) => {
      clearClose(mega);
      closeTimers.set(mega, window.setTimeout(() => {
        if (!mega.matches(':hover') && !mega.contains(document.activeElement)) setState(mega, false);
      }, delay));
    };

    megas.forEach((mega) => {
      const trigger = mega.querySelector('[data-tws3-trigger]');
      const panel = mega.querySelector('[data-tws3-panel]');
      if (!trigger || !panel) return;

      setState(mega, false);

      mega.addEventListener('pointerenter', () => {
        if (hoverCapable.matches) openMega(mega);
      });
      mega.addEventListener('pointerleave', () => {
        if (hoverCapable.matches) scheduleClose(mega);
      });
      mega.addEventListener('focusin', () => openMega(mega));
      mega.addEventListener('focusout', (event) => {
        if (!mega.contains(event.relatedTarget)) scheduleClose(mega, 0);
      });

      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const shouldOpen = !mega.hasAttribute('data-open');
        closeAll(mega);
        setState(mega, shouldOpen);
      });

      panel.addEventListener('click', (event) => event.stopPropagation());
      panel.querySelectorAll('a[href]').forEach((link) => {
        link.addEventListener('click', () => closeAll());
      });
    });

    drawerOpeners.forEach((button) => {
      button.addEventListener('click', () => closeAll());
    });

    document.addEventListener('pointerdown', (event) => {
      if (!header.contains(event.target)) closeAll();
    }, { passive: true });

    header.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const open = megas.find((mega) => mega.hasAttribute('data-open'));
      if (!open) return;
      event.preventDefault();
      const trigger = open.querySelector('[data-tws3-trigger]');
      setState(open, false);
      trigger?.focus();
    });

    const syncBreakpoint = () => {
      if (!desktop.matches) closeAll();
    };
    desktop.addEventListener?.('change', syncBreakpoint);
    syncBreakpoint();
  };

  const collect = (scope = document) => {
    if (scope.matches?.('[data-tws3]')) mount(scope);
    scope.querySelectorAll?.('[data-tws3]').forEach(mount);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => collect(), { once: true });
  } else {
    collect();
  }

  document.addEventListener('shopify:section:load', (event) => collect(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-header-control"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mounted = new WeakSet();

    const mount = (header) => {
      if (!header || mounted.has(header)) return;
      mounted.add(header);

      const megas = Array.from(header.querySelectorAll('[data-twhead-mega]'));
      const drawerOpeners = Array.from(header.querySelectorAll('[data-twhead-open]'));
      const compact = window.matchMedia('(max-width: 1180px)');
      if (!megas.length) return;

      const setState = (mega, open) => {
        mega.toggleAttribute('open', open);
        const summary = mega.querySelector(':scope > summary');
        summary?.setAttribute('aria-expanded', String(open));
      };

      const closeAll = (except = null, restore = false) => {
        megas.forEach((mega) => {
          if (mega === except || !mega.open) return;
          const summary = mega.querySelector(':scope > summary');
          setState(mega, false);
          if (restore) summary?.focus();
        });
      };

      megas.forEach((mega) => {
        const summary = mega.querySelector(':scope > summary');
        if (!summary) return;
        summary.setAttribute('aria-expanded', String(mega.open));

        summary.addEventListener('click', (event) => {
          event.preventDefault();
          const shouldOpen = !mega.open;
          closeAll(mega);
          setState(mega, shouldOpen);
        });

        mega.querySelectorAll('a[href]').forEach((link) => {
          link.addEventListener('click', () => closeAll());
        });
      });

      drawerOpeners.forEach((button) => {
        button.addEventListener('click', () => closeAll());
      });

      document.addEventListener('pointerdown', (event) => {
        if (!header.contains(event.target)) closeAll();
      }, { passive: true });

      header.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const openMega = megas.find((mega) => mega.open);
        if (!openMega) return;
        event.preventDefault();
        const summary = openMega.querySelector(':scope > summary');
        setState(openMega, false);
        summary?.focus();
      });

      const closeOnCompact = () => {
        if (compact.matches) closeAll();
      };
      compact.addEventListener?.('change', closeOnCompact);
      closeOnCompact();
    };

    const collect = (scope = document) => {
      if (scope.matches?.('[data-twhead]')) mount(scope);
      scope.querySelectorAll?.('[data-twhead]').forEach(mount);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => collect(), { once: true });
    } else {
      collect();
    }

    document.addEventListener('shopify:section:load', (event) => collect(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-header-hover-guard-v1"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__twHeaderHoverGuardV1) return;
  window.__twHeaderHoverGuardV1 = true;

  /*
    Hover oder Tastaturfokus haben das Menü bereits geöffnet.
    Der anschließende Click darf diesen gültigen Zustand nicht sofort wieder schließen.
    Geschlossene Menüs und Touchgeräte bleiben von der normalen Toggle-Logik bedienbar.
  */
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest?.('[data-tws3-trigger]');
    if (!trigger) return;

    const mega = trigger.closest('[data-tws3-mega]');
    if (!mega || !mega.hasAttribute('data-open')) return;

    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-leseprobe-deck"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initDeck(root) {
      if (!root || root.dataset.twDeckReady === '1') return;
      var track = root.querySelector('[data-tw-deck-track]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-tw-deck-slide]'));
      if (!track || !slides.length) return;

      var ctrl = root.querySelector('[data-tw-deck-ctrl]');
      var rail = root.querySelector('[data-tw-deck-rail]');
      var curEl = root.querySelector('[data-tw-deck-cur]');
      var prevBtn = root.querySelector('[data-tw-deck-prev]');
      var nextBtn = root.querySelector('[data-tw-deck-next]');
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-tw-deck-goto]'));
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var active = 0;

      function slideW() { return track.clientWidth; }
      function goTo(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: i * slideW(), behavior: 'smooth' });
      }
      function sync() {
        var i = Math.round(track.scrollLeft / Math.max(1, slideW()));
        i = Math.max(0, Math.min(slides.length - 1, i));
        if (i !== active) active = i;
        if (curEl) curEl.textContent = pad(active + 1);
        if (prevBtn) prevBtn.disabled = active === 0;
        if (nextBtn) nextBtn.disabled = active === slides.length - 1;
        dots.forEach(function (d, j) { d.classList.toggle('is-active', j === active); d.setAttribute('aria-current', j === active ? 'true' : 'false'); });
      }

      var raf = 0;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = 0; sync(); });
      }, { passive: true });

      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(active - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(active + 1); });
      dots.forEach(function (d) { d.addEventListener('click', function () { goTo(parseInt(d.getAttribute('data-tw-deck-goto'), 10)); }); });

      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(active + 1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(active - 1); }
        else if (e.key === 'Home') { e.preventDefault(); goTo(0); }
        else if (e.key === 'End') { e.preventDefault(); goTo(slides.length - 1); }
      });

      var reW = 0;
      window.addEventListener('resize', function () {
        clearTimeout(reW);
        reW = setTimeout(function () { track.scrollLeft = active * slideW(); }, 150);
      });

      // ---- zoom ----
      var wrap = root.querySelector('[data-tw-deck-zoomwrap]');
      var zImg = root.querySelector('[data-tw-deck-zoomimg]');
      var zSrc = root.querySelector('[data-tw-deck-zoomsource]');
      var zTxt = root.querySelector('[data-tw-deck-zoomtext]');
      var zPos = root.querySelector('[data-tw-deck-zoompos]');
      var zPrev = root.querySelector('[data-tw-deck-zoomprev]');
      var zNext = root.querySelector('[data-tw-deck-zoomnext]');
      var zCloses = Array.prototype.slice.call(root.querySelectorAll('[data-tw-deck-zoomclose]'));
      var zFile = 0, zPage = 0, lastFocus = null;

      // portal: lift the overlay to <body> so it escapes any transformed ancestor's stacking context
      if (wrap && wrap.id) {
        Array.prototype.forEach.call(document.querySelectorAll('#' + (window.CSS && CSS.escape ? CSS.escape(wrap.id) : wrap.id)), function (n) { if (n !== wrap) n.remove(); });
        document.body.appendChild(wrap);
      }

      function filePages(f) {
        return Array.prototype.slice.call(root.querySelectorAll('[data-tw-deck-zoom][data-file="' + f + '"]'))
          .filter(function (b) { return b.querySelector('img'); })
          .reduce(function (acc, b) {
            var p = parseInt(b.getAttribute('data-page'), 10);
            if (!acc.some(function (x) { return x.page === p; })) {
              var img = b.querySelector('img');
              acc.push({ page: p, src: img.currentSrc || img.src, cap: b.getAttribute('data-cap') || '' });
            }
            return acc;
          }, []).sort(function (a, b) { return a.page - b.page; });
      }
      function renderZoom() {
        var pages = filePages(zFile);
        if (!pages.length) return;
        var idx = Math.max(0, pages.findIndex(function (p) { return p.page === zPage; }));
        if (idx < 0) idx = 0;
        var cur = pages[idx];
        zImg.src = cur.src; zImg.alt = cur.cap;
        if (zSrc) zSrc.textContent = cur.cap;
        if (zPos) zPos.textContent = (idx + 1) + ' / ' + pages.length;
        var slide = slides[zFile];
        var passage = slide ? slide.querySelector('[data-tw-deck-passage]') : null;
        var pull = slide ? slide.querySelector('[data-tw-deck-pull]') : null;
        var html = passage ? passage.innerHTML : '';
        if (pull && pull.textContent && pull.textContent.trim()) { html += '<p class="tw-deck__zoom-pull">' + pull.textContent + '</p>'; }
        if (zTxt) zTxt.innerHTML = html;
        if (zPrev) zPrev.disabled = idx === 0;
        if (zNext) zNext.disabled = idx === pages.length - 1;
      }
      function stepZoom(dir) {
        var pages = filePages(zFile);
        var idx = pages.findIndex(function (p) { return p.page === zPage; });
        idx = Math.max(0, Math.min(pages.length - 1, idx + dir));
        zPage = pages[idx].page; renderZoom();
      }
      function openZoom(f, p) {
        zFile = f; zPage = p; renderZoom();
        wrap.hidden = false; wrap.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
        lastFocus = document.activeElement;
        var c = zCloses[0]; if (c) c.focus();
      }
      function closeZoom() {
        wrap.hidden = true; wrap.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }
      root.querySelectorAll('[data-tw-deck-zoom]').forEach(function (b) {
        b.addEventListener('click', function () {
          openZoom(parseInt(b.getAttribute('data-file'), 10), parseInt(b.getAttribute('data-page'), 10));
        });
      });
      if (zPrev) zPrev.addEventListener('click', function () { stepZoom(-1); });
      if (zNext) zNext.addEventListener('click', function () { stepZoom(1); });
      zCloses.forEach(function (b) { b.addEventListener('click', closeZoom); });
      document.addEventListener('keydown', function (e) {
        if (wrap.hidden) return;
        if (e.key === 'Escape') closeZoom();
        else if (e.key === 'ArrowRight') stepZoom(1);
        else if (e.key === 'ArrowLeft') stepZoom(-1);
      });

      if (ctrl) ctrl.hidden = false;
      if (rail) rail.hidden = false;
      root.classList.add('is-ready');
      root.dataset.twDeckReady = '1';
      sync();
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-tw-deck]').forEach(initDeck);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else { initAll(); }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-leseprobe-reader"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initReader(root) {
      if (!root || root.dataset.twReaderReady === '1') return;
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-tw-reader-tab]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-tw-reader-panel]'));
      if (!tabs.length || !panels.length) return;
      var controls = root.querySelector('[data-tw-reader-controls]');
      var current = root.querySelector('[data-tw-reader-current]');
      var prev = root.querySelector('[data-tw-reader-prev]');
      var next = root.querySelector('[data-tw-reader-next]');
      var index = 0;

      function pad(n) { return (n < 10 ? '0' : '') + n; }

      function select(i, focusTab) {
        i = (i + tabs.length) % tabs.length;
        index = i;
        tabs.forEach(function (t, j) {
          var on = j === i;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          t.classList.toggle('is-active', on);
        });
        panels.forEach(function (p, j) {
          if (j === i) {
            p.hidden = false;
            p.classList.remove('is-active');
            void p.offsetWidth;           // reflow so the reveal animation restarts
            p.classList.add('is-active');
          } else {
            p.hidden = true;
            p.classList.remove('is-active');
          }
        });
        if (current) current.textContent = pad(i + 1);
        if (focusTab) tabs[i].focus();
      }

      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(i, false); });
      });

      root.querySelector('[data-tw-reader-list]').addEventListener('keydown', function (e) {
        var k = e.key;
        if (k === 'ArrowDown' || k === 'ArrowRight') { e.preventDefault(); select(index + 1, true); }
        else if (k === 'ArrowUp' || k === 'ArrowLeft') { e.preventDefault(); select(index - 1, true); }
        else if (k === 'Home') { e.preventDefault(); select(0, true); }
        else if (k === 'End') { e.preventDefault(); select(tabs.length - 1, true); }
      });

      if (prev) prev.addEventListener('click', function () { select(index - 1, false); });
      if (next) next.addEventListener('click', function () { select(index + 1, false); });
      if (controls) controls.hidden = false;

      root.classList.add('is-ready');
      root.dataset.twReaderReady = '1';
      select(0, false);
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-tw-reader]').forEach(initReader);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-module-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGrid(root) {
      if (!root || root.dataset.twMgridReady === '1') return;
      var chips = Array.prototype.slice.call(root.querySelectorAll('[data-filter]'));
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-tw-mgrid-item]'));
      var empty = root.querySelector('[data-tw-mgrid-empty]');
      var count = root.querySelector('[data-tw-mgrid-count]');
      if (!chips.length || !items.length) return;
      var total = items.length;
      function apply(filter) {
        var shown = 0;
        items.forEach(function (it) {
          var ok = filter === 'all' || it.getAttribute('data-area') === filter;
          it.hidden = !ok;
          if (ok) shown++;
        });
        if (empty) empty.hidden = shown !== 0;
        if (count) count.textContent = shown + ' / ' + total;
      }
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          chips.forEach(function (c) { c.classList.toggle('is-active', c === chip); c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
          apply(chip.getAttribute('data-filter'));
        });
      });
      root.dataset.twMgridReady = '1';
    }
    function initAll(scope) { (scope || document).querySelectorAll('[data-tw-mgrid]').forEach(initGrid); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { initAll(); }); }
    else { initAll(); }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-part-modules"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initAcc(root) {
      if (!root || root.dataset.twAccReady === '1') return;
      var list = root.querySelector('[data-tw-acc]');
      if (!list) return;
      var items = Array.prototype.slice.call(list.querySelectorAll('[data-tw-acc-item]'));
      if (!items.length) return;
      function setOpen(item, open) {
        var btn = item.querySelector('[data-tw-acc-btn]');
        var panel = item.querySelector('[data-tw-acc-panel]');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.classList.toggle('is-open', open);
      }
      list.classList.add('is-ready');
      items.forEach(function (item, i) { setOpen(item, i === 0); });
      items.forEach(function (item) {
        var btn = item.querySelector('[data-tw-acc-btn]');
        btn.addEventListener('click', function () {
          var isOpen = btn.getAttribute('aria-expanded') === 'true';
          if (isOpen) { setOpen(item, false); return; }
          items.forEach(function (other) { setOpen(other, other === item); });
        });
      });
      var btns = items.map(function (it) { return it.querySelector('[data-tw-acc-btn]'); });
      list.addEventListener('keydown', function (e) {
        var idx = btns.indexOf(document.activeElement);
        if (idx < 0) return;
        if (e.key === 'ArrowDown') { e.preventDefault(); btns[(idx + 1) % btns.length].focus(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); btns[(idx - 1 + btns.length) % btns.length].focus(); }
        else if (e.key === 'Home') { e.preventDefault(); btns[0].focus(); }
        else if (e.key === 'End') { e.preventDefault(); btns[btns.length - 1].focus(); }
      });
      root.dataset.twAccReady = '1';
    }
    function initAll(scope) { (scope || document).querySelectorAll('[data-tw-acc-root]').forEach(initAcc); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { initAll(); }); }
    else { initAll(); }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-site-header-v5"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__twLuxuryHeaderV5) return;
  window.__twLuxuryHeaderV5 = true;

  const mounted = new WeakSet();
  const FOCUSABLE = 'a[href],button:not([disabled]),summary,[tabindex]:not([tabindex="-1"])';

  const mount = (header) => {
    if (!header || mounted.has(header)) return;
    mounted.add(header);

    const chrome = header.querySelector('[data-twx5-chrome]');
    const scrim = header.querySelector('[data-twx5-scrim]');
    const megaItems = [...header.querySelectorAll('[data-twx5-mega]')];
    const drawer = header.querySelector('[data-twx5-drawer]');
    const drawerOpen = header.querySelector('[data-twx5-drawer-open]');
    const drawerClose = header.querySelector('[data-twx5-drawer-close]');
    const desktop = window.matchMedia('(min-width: 1181px)');
    const hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 1181px)');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const shrink = header.dataset.shrink === 'true';
    const autoHide = header.dataset.autoHide === 'true';
    const threshold = Number.parseInt(header.dataset.scrollThreshold || '36', 10);

    let activeMega = null;
    let openTimer = 0;
    let closeTimer = 0;
    let lastDrawerFocus = null;
    let lastScrollY = window.scrollY;
    let scrollTicking = false;

    const clearTimers = () => {
      window.clearTimeout(openTimer);
      window.clearTimeout(closeTimer);
      openTimer = 0;
      closeTimer = 0;
    };

    const syncPanelTop = () => {
      if (!chrome) return;
      header.style.setProperty('--twx5-panel-top', `${Math.max(0, chrome.getBoundingClientRect().bottom)}px`);
    };

    const setScrim = (open) => {
      if (!scrim) return;
      scrim.toggleAttribute('data-open', open);
      scrim.tabIndex = open ? 0 : -1;
    };

    const setRoute = (mega, key) => {
      mega.querySelectorAll('[data-twx5-route]').forEach((route) => {
        route.classList.toggle('is-active', route.dataset.routeKey === key);
      });
      mega.querySelectorAll('[data-twx5-route-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.routeKey !== key;
      });
    };

    const closeMega = (mega = activeMega, restoreFocus = false) => {
      if (!mega) return;
      const trigger = mega.querySelector('[data-twx5-trigger]');
      const panel = mega.querySelector('[data-twx5-panel]');
      mega.removeAttribute('data-open');
      trigger?.setAttribute('aria-expanded', 'false');
      if (activeMega === mega) activeMega = null;
      if (!activeMega && drawer?.getAttribute('aria-hidden') !== 'false') setScrim(false);
      const finish = () => {
        if (!mega.hasAttribute('data-open') && panel) panel.hidden = true;
      };
      if (reduceMotion.matches) finish();
      else window.setTimeout(finish, 390);
      if (restoreFocus) trigger?.focus({ preventScroll: true });
    };

    const closeAllMegas = (restoreFocus = false) => {
      clearTimers();
      megaItems.forEach((mega) => closeMega(mega, restoreFocus && mega === activeMega));
    };

    const openMega = (mega) => {
      if (!desktop.matches || !mega) return;
      clearTimers();
      if (activeMega && activeMega !== mega) closeMega(activeMega);
      const trigger = mega.querySelector('[data-twx5-trigger]');
      const panel = mega.querySelector('[data-twx5-panel]');
      if (!trigger || !panel) return;
      syncPanelTop();
      panel.hidden = false;
      activeMega = mega;
      window.requestAnimationFrame(() => {
        mega.setAttribute('data-open', '');
        trigger.setAttribute('aria-expanded', 'true');
        setScrim(true);
      });
    };

    const scheduleOpen = (mega) => {
      clearTimers();
      openTimer = window.setTimeout(() => openMega(mega), 95);
    };

    const scheduleClose = (mega) => {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => {
        if (!mega.matches(':hover') && !mega.contains(document.activeElement)) closeMega(mega);
      }, 190);
    };

    megaItems.forEach((mega) => {
      const trigger = mega.querySelector('[data-twx5-trigger]');
      const panel = mega.querySelector('[data-twx5-panel]');
      if (!trigger || !panel) return;
      trigger.setAttribute('aria-expanded', 'false');
      panel.hidden = true;

      mega.addEventListener('pointerenter', () => {
        if (hoverCapable.matches) scheduleOpen(mega);
      });
      mega.addEventListener('pointerleave', () => {
        if (hoverCapable.matches) scheduleClose(mega);
      });
      mega.addEventListener('focusin', () => openMega(mega));
      mega.addEventListener('focusout', (event) => {
        if (!mega.contains(event.relatedTarget)) scheduleClose(mega);
      });
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        mega.hasAttribute('data-open') ? closeMega(mega, true) : openMega(mega);
      });
      panel.addEventListener('pointerenter', clearTimers);
      panel.addEventListener('pointerleave', () => scheduleClose(mega));
      panel.addEventListener('click', (event) => event.stopPropagation());

      mega.querySelectorAll('[data-twx5-route]').forEach((route) => {
        const activate = () => setRoute(mega, route.dataset.routeKey);
        route.addEventListener('pointerenter', activate);
        route.addEventListener('focus', activate);
      });
    });

    const openDrawer = () => {
      if (!drawer || !drawerOpen) return;
      closeAllMegas();
      lastDrawerFocus = document.activeElement;
      drawer.hidden = false;
      drawer.inert = false;
      drawer.setAttribute('aria-hidden', 'false');
      drawerOpen.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('twx5-scroll-lock');
      setScrim(true);
      window.requestAnimationFrame(() => {
        drawer.setAttribute('data-open', '');
        drawerClose?.focus({ preventScroll: true });
      });
    };

    const closeDrawer = (restoreFocus = true) => {
      if (!drawer || drawer.getAttribute('aria-hidden') === 'true') return;
      drawer.removeAttribute('data-open');
      drawer.setAttribute('aria-hidden', 'true');
      drawerOpen?.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('twx5-scroll-lock');
      setScrim(false);
      const finish = () => {
        if (drawer.getAttribute('aria-hidden') === 'true') {
          drawer.hidden = true;
          drawer.inert = true;
        }
      };
      if (reduceMotion.matches) finish();
      else window.setTimeout(finish, 460);
      if (restoreFocus && lastDrawerFocus instanceof HTMLElement) lastDrawerFocus.focus({ preventScroll: true });
    };

    drawerOpen?.addEventListener('click', openDrawer);
    drawerClose?.addEventListener('click', () => closeDrawer());
    scrim?.addEventListener('click', () => {
      if (drawer?.getAttribute('aria-hidden') === 'false') closeDrawer();
      else closeAllMegas();
    });

    drawer?.querySelectorAll('a[href]').forEach((link) => {
      link.addEventListener('click', () => closeDrawer(false));
    });

    drawer?.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab') return;
      const focusable = [...drawer.querySelectorAll(FOCUSABLE)].filter((el) => !el.hidden && el.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    document.addEventListener('pointerdown', (event) => {
      if (activeMega && !header.contains(event.target)) closeAllMegas();
    }, { passive: true });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (drawer?.getAttribute('aria-hidden') === 'false') {
        event.preventDefault();
        closeDrawer();
      } else if (activeMega) {
        event.preventDefault();
        closeMega(activeMega, true);
      }
    });

    const updateScrollState = () => {
      scrollTicking = false;
      const y = Math.max(0, window.scrollY);
      header.dataset.scrolled = String(shrink && y > threshold);
      if (autoHide && desktop.matches && !activeMega && drawer?.getAttribute('aria-hidden') !== 'false') {
        const movingDown = y > lastScrollY + 6;
        const movingUp = y < lastScrollY - 6;
        if (movingDown && y > 180) header.dataset.hidden = 'true';
        if (movingUp || y < 80) header.dataset.hidden = 'false';
      } else {
        header.dataset.hidden = 'false';
      }
      lastScrollY = y;
      syncPanelTop();
    };

    const onScroll = () => {
      if (scrollTicking) return;
      scrollTicking = true;
      window.requestAnimationFrame(updateScrollState);
    };

    const onBreakpoint = () => {
      syncPanelTop();
      if (!desktop.matches) closeAllMegas();
      if (desktop.matches && drawer?.getAttribute('aria-hidden') === 'false') closeDrawer(false);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', syncPanelTop, { passive: true });
    desktop.addEventListener?.('change', onBreakpoint);
    updateScrollState();
    onBreakpoint();
  };

  const collect = (scope = document) => {
    if (scope.matches?.('[data-twx5]')) mount(scope);
    scope.querySelectorAll?.('[data-twx5]').forEach(mount);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => collect(), { once: true });
  else collect();
  document.addEventListener('shopify:section:load', (event) => collect(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
